import ClearIcon from "@mui/icons-material/Clear";
import { Avatar, Grid, IconButton, Tooltip } from "@mui/material";
import React, { useContext, useEffect } from "react";
import FileBase64 from "react-file-base64";
import { useTranslation } from "react-i18next";
import cameraplus2 from "../../assets/AddPhotoIcon.svg";
import cameraIcon from "../../assets/cameraIcon.svg";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";

export default function ProfileUpload(props) {
  const [profile, setProfile] = React.useState(cameraplus2);
  const [file, setFile] = React.useState({});
  const { t } = useTranslation();
  const { darkMode, setDarkMode } = useContext(ThemeContext);
  const [state, setState] = React.useState({
    profilePhoto: "",
  });

  useEffect(() => {
    if (props?.resetTrigger !== undefined && props?.resetTrigger !== null) {
      setProfile("");
      props.onsetProfile("");
      setFile({});
    }
  }, [props?.resetTrigger]);

  const handleProfile = (file) => {
    if (
      file.type === "image/png" ||
      file.type === "image/jpeg" ||
      file.type === "image/jpg"
    ) {
      let fileSize = file.size.split(" ")[0];
      let size = parseInt(fileSize);
      if (size <= 2048) {
        setFile(file);
        setState({
          ...state,
          profilePhoto: file.base64.split(",")[1],
        });
        props.onsetProfile(file);
        setProfile(file.base64);
      } else {
        setFile({});
        setProfile("");
        Toast(t("IMAGE_SIZE_LESS_ERROR"), "error");
      }
    } else {
      setFile({});
      Toast(t("VALID_IMAGE_ERROR"), "error");
    }
  };

  const handleClearProfile = () => {
    setProfile("");
    setFile({});
    props.onsetProfile("");
  };

  return (
    <>
      <Grid
        container
        display={"flex"}
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <div
          style={{
            borderStyle: "dashed ",
            borderRadius: "50%",
            padding: "5px",
            color: "#D2D2D2",
          }}
        >
          <Tooltip title={props.profilePhoto ? t("PROFILE_UPLOAD") : ""}>
            <IconButton
              variant="contained"
              component="label"
              style={{
                position: "relative",
                width: "210px",
                height: "210px",
                font: "normal normal normal 18px/24px Roboto",
                letterSpacing: "0px",
              }}
              disabled={props.disabled}
            >
              {props.profilePhoto !== undefined && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "-5px",
                    right: "10px",
                    borderRadius: "50%",
                    padding: "2.5px",
                  }}
                ></div>
              )}
              {props.profilePhoto ? (
                <Avatar
                  className="ImageContent"
                  alt=""
                  src={props.profilePhoto}
                  style={{
                    height: "200px",
                    width: "200px",
                    zIndex: "99",
                    borderRadius: "50%",
                  }}
                />
              ) : (
                <>
                  <Avatar
                    className="ImageContent"
                    alt=""
                    // Dynamically set the src based on dark mode
                    src={cameraIcon}
                    style={{
                      height: "100%",
                      width: "100%",
                      borderRadius: "50%",
                      backgroundColor: darkMode
                        ? "rgba(221, 221, 221, 0.15)"
                        : "#F4F6F8",
                    }}
                    sx={[
                      () => ({
                        "& .MuiAvatar-img": {
                          width: "49px",
                          height: "42px",
                          textAlign: "center",
                          objectFit: "cover",
                          color: "transparent",
                          textIndent: "10000px",
                        },
                      }),
                    ]}
                  />
                  <div
                    style={{
                      fontSize: "16px",
                      position: "absolute",
                      top: "68%",
                      zIndex: "1",
                      color: "#C3C5C7",
                      justifyContent: "center",
                    }}
                  >
                    {t("PURPOSEPIC")}
                  </div>
                  <Grid style={{ display: "none" }}>
                    <FileBase64
                      multiple={false}
                      onDone={(file) => handleProfile(file)}
                    />
                  </Grid>
                </>
              )}
              <Grid style={{ display: "none" }}>
                <FileBase64
                  multiple={false}
                  onDone={(file) => handleProfile(file)}
                />
              </Grid>
            </IconButton>
          </Tooltip>
          {(props.uploadPhoto === "dealerProfile" ||
            props.uploadPhoto === "userProfile" ||
            props.uploadPhoto === "customerProfile") &&
            props.profilePhoto && (
              <Tooltip
                title={t("CLEAREPROFILEPHOTO")}
                style={{ left: "300%", top: "100%" }}
              >
                <div style={{ position: "relative", display: "inline-block" }}>
                  <ClearIcon
                    style={{
                      color: "white",
                      backgroundColor: "#949596",
                      borderRadius: "50%",
                      position: "absolute",
                      marginTop: "50px",
                      marginLeft: "-22px",
                      transform: "translate(-50%, 50%)",
                      zIndex: 1,
                    }}
                    onClick={handleClearProfile}
                  />
                </div>
              </Tooltip>
            )}

          {props.profilePhoto && !props.disabled && (
            <Tooltip
              title={t("CLEAREPROFILEPHOTO")}
              style={{ left: "300%", top: "100%" }}
            >
              <div style={{ position: "relative", display: "inline-block" }}>
                <ClearIcon
                  style={{
                    color: "white",
                    backgroundColor: "#949596",
                    borderRadius: "50%",
                    position: "absolute",
                    marginTop: "50px",
                    marginLeft: "-22px",
                    transform: "translate(-50%, 50%)",
                    zIndex: 1,
                  }}
                  onClick={handleClearProfile}
                />
              </div>
            </Tooltip>
          )}
        </div>
        <Grid
          direction="row"
          display="flex"
          alignItems="flex-end"
          style={{
            color: darkMode ? "rgba(195, 197, 199, 1)" : "#C3C5C7",
            opacity: 1,
            fontSize: "12px",
            paddingTop: "34px",
            justifyContent: "center",
          }}
        >
          {t("PURPOSECON")}
        </Grid>
      </Grid>
    </>
  );
}

ProfileUpload.defaultProps = {
  disabled: false,
};
